import { COOKIE_PARAM_NAME } from '../consts/cookies.consts';
import CookieService from '../services/cookie.service';

export const savePathRedirect = () => {
    const currentPath = window.location.pathname;
    CookieService.set(COOKIE_PARAM_NAME.REDIRECT, currentPath);
};
